import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { httpOptions } from "./headers";

export interface UserSearchQuery {
  filter?: string;
  page?: number;
  size?: number;
  tenantId?: string;
}

@Injectable({ providedIn: 'root' })

export class UsersManagementService {

  private usersManagementUrl = environment.usersManagementUrl;
  private userAuthUrl = environment.authUrl;

  private httpOptions(session: string) {
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + session
      }),
    };
  };

  constructor(private http: HttpClient) { }

  public getMe() {
    const token = JSON.parse(sessionStorage.getItem('authToken') as string).token;
    return this.http.get<any>(this.usersManagementUrl + '/me', this.httpOptions(token));
  }

  public getAllUsers() {
    const token = JSON.parse(sessionStorage.getItem('authToken') as string).token;
    return this.http.get<any>(this.usersManagementUrl + '/allUsers', this.httpOptions(token));
  }

  // not sure this is needed
  public addUser(user: any) {
    return this.http.post<any>(this.usersManagementUrl + '/add', user, httpOptions);
  }

  // not sure this is needed
  public resetUserPassword(body: any) {
    const token = JSON.parse(sessionStorage.getItem('authToken') as string).token;
    return this.http.put<any>(this.userAuthUrl + "/reset", body, this.httpOptions(token));
  }

  public updateUser(id: string, user: any) {
    const token = JSON.parse(sessionStorage.getItem('authToken') as string).token;
    return this.http.put<any>(this.usersManagementUrl + '/' + encodeURIComponent(id) + '/edit', user, this.httpOptions(token));
  }

  public updateUserLanguage(id: string, user: any) {
    const token = JSON.parse(sessionStorage.getItem('authToken') as string).token;
    return this.http.put<any>(this.usersManagementUrl + '/me/language', user, this.httpOptions(token));
  }

  public registerUser(body: any) {
    const token = JSON.parse(sessionStorage.getItem('authToken') as string).token;
    return this.http.post<any>(this.userAuthUrl + "/register", body, this.httpOptions(token));

  }

  public assignUserTenant(userId: string, body: { tenantId: string }) {
    const token = JSON.parse(sessionStorage.getItem('authToken') as string).token;
    return this.http.put<any>(this.usersManagementUrl + '/' + encodeURIComponent(userId) + '/tenant', body,
      this.httpOptions(token));
  }

  // not sure this is needed
  public removeUser() {

  }

  public resetUserPass(id: any) {
    const token = JSON.parse(sessionStorage.getItem('authToken') as string).token;
    return this.http.put<any>(this.usersManagementUrl + '/' + encodeURIComponent(id) + '/reset-password', {}, this.httpOptions(token));
  }

  public forceUserPassChange(id: any) {
    const token = JSON.parse(sessionStorage.getItem('authToken') as string).token;
    return this.http.put<any>(this.usersManagementUrl + '/' + encodeURIComponent(id) + '/force-change-pwd', {}, this.httpOptions(token));
  }

  public changeUserActiveStatus(id: any) {
    const token = JSON.parse(sessionStorage.getItem('authToken') as string).token;
    return this.http.put<any>(this.usersManagementUrl + '/' + encodeURIComponent(id) + '/update-active', {}, this.httpOptions(token));

  }

  public searchUsers(query: UserSearchQuery) {
    const token = JSON.parse(sessionStorage.getItem('authToken') as string).token;
    let params = new HttpParams()
      .set('page', String(query.page ?? 0))
      .set('size', String(query.size ?? 10));
    if (query.filter) {
      params = params.set('filter', query.filter);
    }
    if (query.tenantId) {
      params = params.set('tenantId', query.tenantId);
    }
    return this.http.get<any>(this.usersManagementUrl + '/search', {
      ...this.httpOptions(token),
      params
    });
  }
}
